import type { Quote } from '@shared/types/quotes'

export const mockQuotes: Quote[] = [
  {
    id: 'qt_001',
    amount: 2500.00,
    currency: 'usd',
    status: 'draft',
    quoteNumber: 'QT-DRAFT',
    customer: 'New balkan',
    customerEmail: 'example@gmail.com',
    expiration: null,
    send: null,
    created: new Date('2024-10-01').toISOString(),
  },
  {
    id: 'qt_002',
    amount: 20.00,
    currency: 'usd',
    status: 'accepted',
    quoteNumber: 'QT-37ACBE5C',
    customer: 'New balkan',
    customerEmail: 'example@gmail.com',
    expiration: null,
    send: null,
    created: new Date('2024-10-05').toISOString(),
  },
  {
    id: 'qt_003',
    amount: 920.00,
    currency: 'usd',
    status: 'outstanding',
    quoteNumber: 'QT-8F2D4A1B',
    customer: 'New balkan',
    customerEmail: 'example@gmail.com',
    expiration: new Date('2024-10-10').toISOString(),
    send: new Date('2024-10-10').toISOString(),
    created: new Date('2024-10-10').toISOString(),
  },
  {
    id: 'qt_004',
    amount: 1320.89,
    currency: 'usd',
    status: 'cancelled',
    quoteNumber: 'QT-5B9E3C7D',
    customer: 'New balkan',
    customerEmail: 'example@gmail.com',
    expiration: new Date('2024-10-20').toISOString(),
    send: new Date('2024-10-20').toISOString(),
    created: new Date('2024-10-20').toISOString(),
  },
  {
    id: 'qt_005',
    amount: 4500.00,
    currency: 'usd',
    status: 'outstanding',
    quoteNumber: 'QT-A1B2C3D4',
    customer: 'Tech Innovators Inc',
    customerEmail: 'contact@techinnovators.com',
    expiration: new Date('2024-11-15').toISOString(),
    send: new Date('2024-10-25').toISOString(),
    created: new Date('2024-10-22').toISOString(),
  },
  {
    id: 'qt_006',
    amount: 750.00,
    currency: 'usd',
    status: 'accepted',
    quoteNumber: 'QT-6E7F8G9H',
    customer: 'Global Solutions Ltd',
    customerEmail: 'info@globalsolutions.com',
    expiration: new Date('2024-11-01').toISOString(),
    send: new Date('2024-10-15').toISOString(),
    created: new Date('2024-10-12').toISOString(),
  },
  {
    id: 'qt_007',
    amount: 1800.00,
    currency: 'usd',
    status: 'draft',
    quoteNumber: 'QT-DRAFT',
    customer: 'Enterprise Corp',
    customerEmail: 'sales@enterprisecorp.com',
    expiration: null,
    send: null,
    created: new Date('2024-10-28').toISOString(),
  },
  {
    id: 'qt_008',
    amount: 3200.00,
    currency: 'usd',
    status: 'outstanding',
    quoteNumber: 'QT-2K3L4M5N',
    customer: 'Digital Ventures',
    customerEmail: 'hello@digitalventures.io',
    expiration: new Date('2024-11-20').toISOString(),
    send: new Date('2024-11-01').toISOString(),
    created: new Date('2024-10-30').toISOString(),
  },
  {
    id: 'qt_009',
    amount: 950.00,
    currency: 'usd',
    status: 'cancelled',
    quoteNumber: 'QT-9P8Q7R6S',
    customer: 'Startup Hub',
    customerEmail: 'team@startuphub.com',
    expiration: new Date('2024-10-18').toISOString(),
    send: new Date('2024-10-08').toISOString(),
    created: new Date('2024-10-05').toISOString(),
  },
  {
    id: 'qt_010',
    amount: 5500.00,
    currency: 'usd',
    status: 'accepted',
    quoteNumber: 'QT-X4Y5Z6W7',
    customer: 'Mega Corporation',
    customerEmail: 'procurement@megacorp.com',
    expiration: new Date('2024-11-30').toISOString(),
    send: new Date('2024-11-05').toISOString(),
    created: new Date('2024-11-02').toISOString(),
  },
]
